import { matchPath } from 'react-router-dom';

import { routesConfig } from '../configs/routes';
import type { LayoutType } from '../../shared/types/LayoutType';

export function resolveRouteLayout(pathname: string): LayoutType | undefined {
  for (const route of routesConfig) {
    const match = matchPath(
      { path: route.path, end: route.path === '/' },
      pathname
    );

    if (match) {
      return route.meta?.layout;
    }
  }

  return undefined;
}

export function isPublicGalleryRoute(pathname: string): boolean {
  return pathname.startsWith('/gallery/');
}
